import {
  ptacAmperageConstraint,
  PtacPreferencesRecord,
  ptacVoltageConstraint
} from '@alpinehomeair/common';
import { SegmentedControlOption } from 'components/inputs/segmented-control-types';
import {
  PtacElectricalDefaults,
  PtacElectricalFilter,
  PtacElectricalFilterOptionValue
} from 'utils/ptac-electrical-filter-types';

export const PTAC_ELECTRICAL_ANY_LABEL = 'Any';

export const DEFAULT_PTAC_ELECTRICAL_FILTER: PtacElectricalFilter = {
  mode: 'default'
};

export const NO_PTAC_ELECTRICAL_DEFAULTS: PtacElectricalDefaults = {
  voltage: null,
  amperage: null
};

export function ptacElectricalDefaultsOf(
  record: PtacPreferencesRecord | null | undefined
): PtacElectricalDefaults {
  return {
    voltage: ptacVoltageConstraint(record),
    amperage: ptacAmperageConstraint(record)
  };
}

export function resolvePtacElectricalFilter(
  filter: PtacElectricalFilter,
  defaultValue: string | null
): string | null {
  if (filter.mode === 'any') return null;
  if (filter.mode === 'value') return filter.value;
  return defaultValue;
}

export function ptacElectricalFilterFromOption(
  value: PtacElectricalFilterOptionValue
): PtacElectricalFilter {
  return value === 'any' ? { mode: 'any' } : { mode: 'value', value };
}

export function ptacElectricalFilterOptions(
  universe: string[],
  resolved: string | null
): SegmentedControlOption<PtacElectricalFilterOptionValue>[] {
  const values =
    resolved !== null && !universe.includes(resolved)
      ? [...universe, resolved]
      : universe;
  return [
    { value: 'any', label: PTAC_ELECTRICAL_ANY_LABEL },
    ...values.map((value) => ({ value, label: value }))
  ];
}

export function isPtacElectricalFilterApplied(
  filter: PtacElectricalFilter,
  defaultValue: string | null
): boolean {
  return resolvePtacElectricalFilter(filter, defaultValue) !== null;
}
